import { render, staticRenderFns } from "./approval-progress-step.vue?vue&type=template&id=f9c3b9b4&scoped=true&"
import script from "./approval-progress-step.vue?vue&type=script&lang=js&"
export * from "./approval-progress-step.vue?vue&type=script&lang=js&"
import style0 from "./approval-progress-step.vue?vue&type=style&index=0&id=f9c3b9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c3b9b4",
  null
  
)

export default component.exports